module.exports = __webpack_public_path__ + "fonts/020ef7d.woff2";